import React from 'react';
import { ZapIcon } from 'lucide-react';
import { demoInput, demoOutput } from '../../data/samplePrompts';
import { splitPrompt } from '../../utils/prompt';
export function PromptDemo() {
  const segments = splitPrompt(demoInput);
  return <div className="mx-auto mt-12 max-w-3xl" data-id="element-212" data-mp="3gm640dmeo30u">
      <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-213" data-mp="3bnbdepi75a66">
        <h3 className="font-display text-xl font-black text-plum sm:text-2xl" data-id="element-214" data-mp="2ny9z4lmon4sz">
          <ZapIcon className="mr-1.5 inline h-5 w-5 -translate-y-0.5 text-gold-deep" aria-hidden="true" data-id="element-215" data-mp="2nw5x698cgfvc" />
          See it in action
        </h3>
        <span className="text-xs font-bold uppercase tracking-wider text-plum/50" data-id="element-216" data-mp="2xolhhd745gje">ChatGPT · Real Demo</span>
      </div>

      <div className="mt-4 overflow-hidden rounded-2xl border border-gold/40 bg-white" data-id="element-217" data-mp="2swbqruy6ccg2">
        <div className="p-5" data-id="element-218" data-mp="256ze2l3n1m90">
          <p className="text-xs font-black uppercase tracking-wider text-blush" data-id="element-219" data-mp="255xz45ji4fm0">1 · You type this</p>
          <p className="mt-2 whitespace-pre-line rounded-xl bg-cream p-4 text-[13.5px] leading-relaxed text-plum/80" data-id="element-220" data-mp="208fo89lxbqbd">
            {segments.map((s, i) => s.type === 'text' ? <React.Fragment key={i} data-id="element-221" data-mp="1wbw9nhw6ig89">{s.value}</React.Fragment> : <mark key={i} className="rounded bg-blush-soft px-1 font-semibold text-blush-deep" data-id="element-222" data-mp="215gzunrj65ww">[{s.value}]</mark>)}
          </p>
        </div>

        <div className="border-t border-gold/30 p-5" data-id="element-223" data-mp="19di1xvutwt1m">
          <p className="text-xs font-black uppercase tracking-wider text-grape" data-id="element-224" data-mp="19f2vbi5eq5xw">2 · You get this</p>
          <p className="mt-2 font-display text-base font-black text-plum" data-id="element-225" data-mp="1dgo34p333u18">BOOK BLUEPRINT</p>
          <ol className="mt-3 grid gap-3 sm:grid-cols-2" data-id="element-226" data-mp="1icd857xvi34x">
            {demoOutput.map((o, i) => <li key={o.title} className="flex gap-3" data-id="element-227" data-mp="1naoev9svfxix" data-mpi={i}>
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-grape text-[11px] font-black text-white" data-id="element-228" data-mp="2ttmqfr59mp4n">
                  {i + 1}
                </span>
                <div className="min-w-0" data-id="element-229" data-mp="29397i0ypvj1e">
                  <p className="text-sm font-bold text-plum" data-id="element-230" data-mp="291xwbg2xz909">{o.title}</p>
                  <p className="text-sm text-plum/65" data-id="element-231" data-mp="243o2b8syeeg8">{o.desc}</p>
                </div>
              </li>)}
          </ol>
        </div>

        <div className="flex flex-col items-center justify-between gap-1 border-t-2 border-gold bg-grape-deep px-5 py-3 text-center sm:flex-row sm:text-left" data-id="element-232" data-mp="2izm2d26002xq">
          <p className="text-sm font-semibold text-white/85" data-id="element-233" data-mp="1qe2pkg5qyvgn">You copy and paste. No advanced AI skills required.</p>
          <p className="text-sm font-black text-gold-soft" data-id="element-234" data-mp="1lg14jporgm2j">Professional result</p>
        </div>
      </div>
    </div>;
}